import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import OperatorInputField from 'components/input/OperatorInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import { getRuleConfig } from 'helpers/rulesHelper';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';

const StyledInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const VALUE_PROPERTY = 'value';
const OPERATOR_PROPERTY = 'operator';

const inputComponents = {
    [OPERATOR_PROPERTY]: {
        component: OperatorInputField,
        placeholder: null,
        validations: validations.required,
    },
    [VALUE_PROPERTY]: {
        component: RenderTextInputField,
        placeholder: 'resources.products.duration.placeholders.duration',
        validations: [
            validations.required,
            validations.duration,
        ],
    },
};

class DurationRule extends Component {
    config = null;
    rule = null;

    componentDidMount() {
        const {
            initialize,
            value,
            type,
        } = this.props;

        const initialState = {};

        this.rule = getRuleConfig(utils.firstCharToLowerCase(type));
        this.config = this.rule.config;

        utils.each(this.config, (configValue, property) => {
            initialState[property] = value[property] || null;
        });

        initialize(initialState);
    }

    componentDidUpdate(prevProps) {
        const {
            formValues,
            onUpdate,
        } = this.props;

        const diffFormValues = utils.diffObjects(formValues, prevProps.formValues);

        if (!utils.isEmpty(diffFormValues)) {
            return onUpdate(formValues);
        }
    }

    render() {
        const {
            form,
            translate,
        } = this.props;

        if (!this.config) {
            return null;
        }

        return (
            <StyledInputWrapper>
                {
                    utils.map(this.config, (configValue, property) => {
                        const { component, validations } = inputComponents[property];
                        let placeholder = null;
                        let translationKey = `resources.products.${ property }`;

                        if (this.rule.placeholder || inputComponents[property].placeholder) {
                            placeholder = translate(this.rule.placeholder || inputComponents[property].placeholder);
                        }

                        if (property === VALUE_PROPERTY) {
                            translationKey = `resources.products.${ property }.label`;
                        }

                        return (
                            <Field
                                key={ `${ form }-input-${ property }` }
                                component={ component }
                                label={ translate(translationKey) }
                                name={ property }
                                placeholder={ placeholder }
                                validate={ validations }
                            />
                        );
                    })
                }
            </StyledInputWrapper>
        );
    }
}

DurationRule.propTypes = {
    form: PropTypes.string,
    formValues: PropTypes.shape({
        operator: PropTypes.string,
        value: PropTypes.string,
    }),
    initialize: PropTypes.func.isRequired,
    onUpdate: PropTypes.func,
    translate: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.shape({
        operator: PropTypes.string,
        value: PropTypes.string,
    }),
};

const mapStateToProps = (state, props) => {
    const {
        id,
        type,
    } = props;

    const form = `${ type }-${ id }`;

    return {
        form: form,
        formValues: getFormValues(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(mapStateToProps, null),
    reduxForm(),
);

export default enhance(DurationRule);


// WEBPACK FOOTER //
// ./src/pages/discounts/rules/DurationRule.js